const mFeedAssetsContentModalDelete = {
  mFeedAssetsContentModalDelete: {
    alerts: {
      deleteProyecto: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'El curso fue eliminado exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'ELIMINAR',

    messageDelete: {
      element: 'Se eliminará el curso',
      options: 'y todas sus características de forma definitiva.',
      notReversed: 'Esta acción no podrá ser revertida.'
    },

    title: 'Eliminar Curso'
  }
}

export default mFeedAssetsContentModalDelete
